// Module
var code = "<div class=\"fc-user__wrapper\">\n  <fc-media class=\"fc-user__avatar\" params=\"url: avatar, size: 30, fancybox: hasAvatar\"></fc-media>\n  <div class=\"fc-user__name\" data-bind=\"text: name\"></div>\n</div>\n";
// Exports
module.exports = code;